import { render, staticRenderFns } from "./SlideDel.vue?vue&type=template&id=41b3f3a3&scoped=true"
import script from "./SlideDel.vue?vue&type=script&lang=js"
export * from "./SlideDel.vue?vue&type=script&lang=js"
import style0 from "./SlideDel.vue?vue&type=style&index=0&id=41b3f3a3&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b3f3a3",
  null
  
)

export default component.exports